import { Layout } from '@/bloks/Global/Layout';
import { getServerPageConfig } from '@/server/config';
import { getBreadcrumbs } from '@/server/config/getBreadcrumbs';
import { DefaultProps, buildGetStaticProps } from '@/server/slug';
import { GetStaticPaths } from 'next';
import { TeamtailorProvider } from '../../../contexts/teamtailor/TeamtailorProvider';
import { Department, JobAdvertisement, JobLocation } from '../../../contexts/teamtailor/types';
import { fetchAllDepartments, fetchAllJobs, fetchAllLocations } from '../../../server/teamtailor/instance';

// Component based on Storyblok blog post example
// https://github.com/storyblok/nextjs-multilanguage-website/blob/main/pages/%5B%5B...slug%5D%5D.js

interface Props extends DefaultProps {
	jobs: JobAdvertisement[];
	locations: JobLocation[];
	departments: Department[];
}

const Page: React.FC<Props> = ({ jobs, locations, departments, ...props }) => {
	return (
		<TeamtailorProvider value={{ jobs, locations, departments }}>
			<Layout {...props} />
		</TeamtailorProvider>
	);
};

export default Page;

export const getStaticProps = buildGetStaticProps<Props>({
	initialize() {
		const storySlug = 'karriar/lediga-jobb';
		const pageSlug = 'karriar/lediga-jobb';

		return { build: { pageSlug, storySlug } };
	},
	async build(helper) {
		await helper.fetchProps({
			jobs: () => fetchAllJobs(),
			locations: () => fetchAllLocations(),
			departments: () => fetchAllDepartments(),
		});

		const { story } = helper.result!.props;
		const breadcrumbs = await getBreadcrumbs(story.full_slug, story.name, helper.sbParams);

		helper.result!.props.config = getServerPageConfig({
			slug: helper.storySlug,
			story,
			breadcrumbs,
		});
	},
});

export const getStaticPaths: GetStaticPaths = async () => {
	return { paths: [], fallback: 'blocking' };
};
